"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Link.prototype.render = function () {
        var _a = this.props, className = _a.className, colour = _a.colour, hoverColour = _a.hoverColour, href = _a.href, hover = _a.hover, onClick = _a.onClick, size = _a.size, target = _a.target, title = _a.title;
        var defaultColour = "arctic";
        var sizes = {
            link: "transition-fast" + (hover ? " border-b border-transparent pb-0-4 hover:border-" + (hoverColour || colour || defaultColour) : ""),
            inherit: " "
        };
        var style = size && sizes[size] ? sizes[size] : sizes.link;
        var classes = (colour ? "text-" + colour : "text-" + defaultColour) + " cursor-pointer hover:text-" + (hoverColour || colour || defaultColour) + " " + style + (className ? " " + className : "");
        return (React.createElement("a", { href: href || null, onClick: onClick ? function (event) { return onClick(); } : null, className: classes, title: title || null, "aria-label": title || null, role: "link", target: target || null }, this.props.children));
    };
    return Link;
}(React.PureComponent));
exports.Link = Link;
